import moment = require("moment");
import {option, Option} from "ts-option";
import {CodatErrorApiDto, CodatErrorDataApiDto} from "../../api/model/rest";

export default class CodatError {
	constructor(public readonly id: string,
		public readonly creationDateTime: moment.Moment,
		public readonly data: CodatErrorData,
		public readonly referenceNumber: Option<string>,
		public readonly type: string,
		public readonly errorDataType: string,
		public readonly partnerBrand: { id: string, name: string },
		public readonly solved: boolean,
	) {}

	static fromJson(json: CodatErrorApiDto) {
		return new CodatError(json.id, moment(json.creationDateTime), CodatErrorData.fromJson(json.data),
			option(json.referenceNumber), json.type, json.errorDataType, json.partnerBrand, json.solvingData.solved)
	}
}

export class CodatErrorData {
	constructor(public readonly errors: { itemId: string, message: string }[],
		public readonly errorMessage: string) {}

	static fromJson(json: CodatErrorDataApiDto) {
		return new CodatErrorData(json.errors || [], json.errorMessage)
	}
}